import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { TagDto } from '../../dtos/tag.dto';

@Injectable({ providedIn: 'root' })
export class TagCatalogRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getTags(): Observable<TagDto[]> {
    return this.http.get<TagDto[]>(`${this.apiUrl}${API_ENDPOINTS.tags}`);
  }
}
